import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { NAV_LINKS, WHATSAPP_URL, scrollToId } from "../constants";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (id) => {
    setOpen(false);
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 200);
    } else {
      scrollToId(id);
    }
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur-xl border-b border-gray-100" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
        <button
          onClick={() => go("start")}
          className="flex items-center shrink-0"
          aria-label="EMT-Reinigung – zur Startseite"
          data-testid="nav-logo"
        >
          <img
            src="/assets/emt-logo.png"
            alt="EMT-Reinigung – Gebäudereinigung Lehrte"
            className="h-10 sm:h-11 w-auto"
            width="542"
            height="218"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Hauptnavigation">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-ink/80 hover:text-brand transition-colors duration-200"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="lg:hidden flex items-center justify-center w-11 h-11 rounded-full bg-conv text-white hover:bg-conv-dark transition-colors duration-200"
            aria-label="Per WhatsApp anfragen"
            data-testid="nav-whatsapp-mobile"
          >
            <MessageCircle className="w-5 h-5" />
          </a>
          <button
            onClick={() => go("kontakt")}
            className="hidden sm:inline-flex items-center rounded-full bg-conv hover:bg-conv-dark text-white text-sm font-semibold px-6 py-2.5 transition-all duration-200 hover:scale-[1.03] shadow-[0_8px_20px_-8px_rgba(16,185,129,0.6)]"
            data-testid="nav-cta-angebot"
          >
            Kostenloses Angebot
          </button>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden flex items-center justify-center w-11 h-11 text-ink"
            aria-label={open ? "Menü schließen" : "Menü öffnen"}
            aria-expanded={open}
            data-testid="nav-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-xl" data-testid="nav-mobile-panel">
          <nav className="px-5 py-4 flex flex-col" aria-label="Mobile Navigation">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className="text-left py-3.5 text-base font-medium text-ink border-b border-gray-100 last:border-0"
                data-testid={`nav-mobile-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("kontakt")}
              className="mt-4 rounded-full bg-conv text-white font-semibold py-3.5 text-center"
              data-testid="nav-mobile-cta-angebot"
            >
              Kostenloses Angebot
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
